module.exports = __webpack_public_path__ + "img/young-f6h.4aa4fd42.png";